import React from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  Home, 
  BarChart, 
  User,
  LogOut
} from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';

interface MenuItem {
  id: string;
  icon: React.ComponentType<{ size?: number }>;
  label: string;
  path: string;
}

const Sidebar: React.FC = () => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const menuItems: MenuItem[] = [
    {
      id: 'dashboard',
      icon: Home,
      label: 'Dashboard',
      path: '/dashboard'
    },
    {
      id: 'reports',
      icon: BarChart,
      label: 'AI Reports',
      path: '/reports'
    }
  ];

  const isActiveItem = (path: string) => {
    return path === '/dashboard'; // Dashboard is active for this app
  };

  const handleItemClick = (path: string) => {
    navigate(path);
  };

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <aside className="sidebar">
      <div className="sidebar-logo">
        <div style={{ 
          width: '32px', 
          height: '32px', 
          background: 'white',
          borderRadius: '4px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#4e9ed7',
          fontSize: '14px',
          fontWeight: 'bold'
        }}>
          360
        </div>
      </div>
      
      <nav className="sidebar-nav">
        {menuItems.map((item) => {
          const Icon = item.icon;
          return (
            <button
              key={item.id}
              className={`sidebar-item ${isActiveItem(item.path) ? 'sidebar-item-active' : ''}`}
              title={item.label}
              onClick={() => handleItemClick(item.path)}
            >
              <Icon size={24} />
            </button>
          );
        })}
      </nav>
      
      <div className="sidebar-footer">
        {user && (
          <button 
            className="sidebar-item sidebar-user" 
            title={`${user.first_name} ${user.last_name} (${user.role})`}
          >
            <User size={24} />
          </button>
        )}
        <button 
          className="sidebar-item sidebar-logout" 
          title="Logout"
          onClick={handleLogout}
        >
          <LogOut size={24} />
        </button>
      </div>

      {/* User info tooltip on hover */}
      {user && (
        <div className="sidebar-user-info">
          <span className="user-name">{user.first_name} {user.last_name}</span>
          <span className="user-role">{user.role}</span>
        </div>
      )}

    </aside>
  );
};

export default Sidebar;